<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2022-03-01 15:15:31
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Leave\LeaveType\components\newHolidayType.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-03-01 15:37:33
-->
<template>
  <normalDialog
    maxWidth="1000"
    width="70%"
    scrollable
    height="600"
    @close="closeDialog"
    :title="$t('label_essweb_leaveType_form_dialog_editHolidayTypeTitle')"
    :dialog="show"
  >
    <template v-slot:content>
      <Tabler
        :headers="headers"
        :defaultSelect="PorpertyData"
        @select="(sel) => (selected = sel)"
        :items="desserts"
        itemKey="uuid"
        :showSelect="showSelect"
      >
        <template v-slot:item.holiday_type_name="{ item }">{{
          $getCommonLangValue(item.holiday_type_name)
        }}</template>
        <template v-slot:item.holiday_type_code="{ item }">{{
          item.holiday_type_code
        }}</template>
      </Tabler>
    </template>
    <template v-slot:actions>
      <CardActions saveBtn @save="editPorperty" @cancel="closeDialog" />
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "editHolidayType",
  props: ["show", "PorpertyData"],
  computed: {
    ...mapGetters(["companyLang"]),
  },
  data() {
    return {
      selected: [],
      showSelect: true,
      desserts: [],
      headers: [
        {
          text: "label_essweb_holidayType_list_HolidayTypeNameLabel",
          value: "holiday_type_name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_holidayType_list_HolidayTypeCodeLabel",
          value: "holiday_type_code",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
    };
  },
  created() {
    this.getHolidayTypeList();
  },
  watch: {
    PorpertyData(val) {
      this.selected = val;
    },
  },
  methods: {
    closeDialog() {
      this.$emit("close");
    },
    editPorperty: function () {
      this.$emit("editPorperty", this.selected);
    },
    getHolidayTypeList() {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_holi_holiday_type",
        url: "/holiday-type/get-list/",
        data: {},
      }).then((res) => {
        that.desserts = res.data;
      });
    },
  },
};
</script>